import React from 'react';
import styles from './Select.module.scss';
import Message from '../Message/Message';
import ChevronIcon from '../../assets/icons/16/chevron.svg';
import {SelectPropsInterface} from './Select.props.interface';
import useSelectLogic from "../../utils/useSelectLogic";

const Select: React.FC<SelectPropsInterface> = (
    {
        data = {},
        value = null,
        error = null,
        direction,
        parentRef,
        onChange,
        size = 'small',
        label = undefined,
        placeholder = 'Не выбрано',
        disabled = false,
        dropState = false,
        onDropShow,
        onDropHide,
        visibilityItems = 5,
        children,
        ...rest
    }) => {
    const {
        selectRef,
        listRef,
        dropdown,
        hoveredItem,
        directionList,
        handleShow,
        handleHide,
        handleSelect,
        handlePress,
        setHoveredItem,
    } = useSelectLogic({
        data,
        value,
        dropState,
        parentRef,
        onChange,
        direction,
        onDropShow,
        onDropHide,
        disabled,
    });

    return (
        <div
            className={[
                styles.container,
                styles[size],
                disabled ? styles.disabled : null,
                error ? styles.error : null,
                directionList.filter((x) => x).map((x) => styles[x]).join(' '),
            ]
                .filter((x) => x)
                .join(' ')}
            {...rest}
        >
            {label ? <label className={styles.label}>{label}</label> : null}

            <div
                className={[!children ? styles.text : null, styles.trigger]
                    .filter((x) => x)
                    .join(' ')}
                onFocus={handleShow}
                onBlur={handleHide}
                onKeyDown={handlePress}
                ref={selectRef}
                tabIndex={0}
            >
                {children ? (
                    <div className={styles.children}>{children}</div>
                ) : (
                    <>
                        {value !== null && value !== undefined ? (
                            <div className={styles.value}>{data[value]}</div>
                        ) : null}
                        {placeholder &&
                        (value === null || value === undefined || value == -1) ? (
                            <div className={styles.placeholder}>{placeholder}</div>
                        ) : null}
                        <div className={styles.arrow}>
                            <ChevronIcon/>
                        </div>
                    </>
                )}
                {Object.entries(data).length ? (
                    <ul
                        className={[
                            styles.list,
                            dropdown ? styles.isOpen : null,
                            children ? styles.width : null,
                        ]
                            .filter((x) => x)
                            .join(' ')}
                        style={{maxHeight: 41 * (visibilityItems || 7)}}
                        ref={listRef}
                    >
                        {Object.entries(data).map((x: any, i: any) => (
                            <li
                                key={x[0]}
                                className={[
                                    styles.item,
                                    value === Number(x[0]) ? styles.active : null,
                                    hoveredItem === i &&
                                    Number(Object.keys(data)[hoveredItem as any]) !== value
                                        ? styles.hover
                                        : null,
                                ]
                                    .filter((x) => x)
                                    .join(' ')}
                                onClick={() => handleSelect(x[0])}
                                onTouchMove={() => setHoveredItem(i)}
                                onMouseMove={() => setHoveredItem(i)}
                            >
                                {x[1]}
                            </li>
                        ))}
                    </ul>
                ) : null}
            </div>
            {error ? (
                <Message type={'danger'}>{error}</Message>
            ) : null}
        </div>
    );
};

export default Select;
